export default __webpack_public_path__ + "e3d3f42e3e738f800e5ff60eb197ca65.png";